import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";

export const header = {
  paddingTop: 24,
  paddingBottom: 0,
} as const;

export const intro = {
  color: greys.slate,
  fontSize: 14,
  lineHeight: 1.5,
  paddingTop: 10,
  marginBottom: 0,
} as const;

export const counter = {
  fontSize: size.sm,
  color: greys.slate,
  paddingRight: 20,
} as const;

export const room = {
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 2px",
  },
  name: {
    color: greys.dark,
  },
  suggested: {
    fontSize: 13,
  },
  tipContent: {},
} as const;
